import { useAuth } from '../contexts/AuthContext';

/**
 * Unified auth hook. Demo mode now uses real Entra ID (same as production).
 * DemoAuthProvider was removed — all environments authenticate via MSAL.
 */
export const useAuthMode = () => useAuth();
